import axios from 'axios'
import _ from 'lodash'
import queryString from 'query-string';

const server_url = process.env.REACT_APP_SERVER_URL

const createDistributor = async (token, newDistributor) => {
  return await axios
  .post(`${server_url}/api/distributor/adminKC/create`, newDistributor, {
    headers: { authorization: `Bearer ${token}` }
  })
  .then(function (response) {
    console.log('New distributor: ', newDistributor)
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

const listDistributor = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/adminKC/listDistributor?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const countListDistributor = async (token) => {
  return await axios
    .get(`${server_url}/api/distributor/adminKC/count/listDistributor`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const readDistributor = async (token, params) => {
  const query = queryString.stringify(params);
  return await axios
    .get(`${server_url}/api/distributor/adminKC/read?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

const updateDistributor = async (token, sendData) => {
  return await axios
    .post(`${server_url}/api/distributor/adminKC/update`, sendData, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

const deleteMultipleDistributor = async (token, sendData) => {
  return await axios
    .post(`${server_url}/api/distributor/adminKC/deleteMultipleDistributor`, sendData, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

const searchDistributorList = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/adminKC/search/getDistributorList?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const countSearchDistributorList = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/adminKC/count/search/getDistributorList?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

//----CUSTOMER ROUTES---//
const customerListDistributor = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/listDistributor?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerCountListDistributor = async (token) => {
  return await axios
    .get(`${server_url}/api/distributor/customer/count/listDistributor`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerListDistributorByStatus = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/listDistributorByStatus?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerCountListDistributorByStatus = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/count/listDistributorByStatus?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerReadDistributor = async (token, params) => {
  const query = queryString.stringify(params);
  return await axios
    .get(`${server_url}/api/distributor/customer/readDistributor?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

const customerSearchListDistributor = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/search/listDistributor?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerCountSearchListDistributor = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/search/count/listDistributor?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerSearchListDistributorByStatus = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/search/listDistributorByStatus?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerCountSearchListDistributorByStatus = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/search/count/listDistributorByStatus?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerFindSignUpLink = async (params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/findSignUpLink?${query}`)
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const customerReadDistributorWithoutLogin = async (params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/readDistributorWithoutLogin?${query}`)
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}


const listDistributorV2 = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/getDistributorListV2?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const countListDistributorV2 = async (token) => {
  return await axios
    .get(`${server_url}/api/distributor/customer/count/getDistributorListV2`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}


const searchListDistributorV2 = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/search/getDistributorListV2?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const countSearchListDistributorV2 = async (token, params) => {
  const query = queryString.stringify(params);
  return await axios
    .get(`${server_url}/api/distributor/customer/count/search/getDistributorListV2?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}

const oldCustomerGetListDistributor = async (token) => {
  return await axios
    .get(`${server_url}/api/distributor/customer/oldCustomerGetListDistributor`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
} 


const retailerGetDistributorListCheckAccess = async (token, params) => {
  const query = queryString.stringify(params)
  return await axios
    .get(`${server_url}/api/distributor/customer/retailerGetDistributorListCheckAccess?${query}`, {
      headers: { authorization: `Bearer ${token}` }
    })
    .then(function (response) {
      // console.log(response)
      return response.data
    })
    .catch(function (error) {
      return error.response
    })
}


export {
  createDistributor,
  listDistributor,
  countListDistributor,
  readDistributor,
  updateDistributor,
  deleteMultipleDistributor,
  searchDistributorList,
  countSearchDistributorList,
  //CUSTOMER FUNCTION
  customerCountListDistributor,
  customerListDistributor,
  customerListDistributorByStatus,
  customerCountListDistributorByStatus,
  customerReadDistributor,
  customerSearchListDistributor,
  customerCountSearchListDistributor,
  customerSearchListDistributorByStatus,
  customerCountSearchListDistributorByStatus,
  customerFindSignUpLink,
  customerReadDistributorWithoutLogin,
  listDistributorV2,
  countListDistributorV2,
  searchListDistributorV2,
  countSearchListDistributorV2,
  oldCustomerGetListDistributor,
  retailerGetDistributorListCheckAccess
}